import { combineReducers } from "redux";

import * as appleWallet from "./appleWallet";
import * as error from "./error";
import * as googleWallet from "./googleWallet";
import * as isLoading from "./isLoading";
import * as qr from "./qr";
import * as referral from "./referral";

import {
  APPLE_WALLET_CHANNEL,
  GOOGLE_WALLET_CHANNEL,
  PRODUCT_APPLE_WALLET_CHANNEL,
  PRODUCT_GOOGLE_WALLET_CHANNEL,
  PRODUCT_PURL_CHANNEL,
  PRODUCT_QR_CODE_CHANNEL,
  QR_CODE_CHANNEL,
} from "../../constants";

export const REFERRAL_CHANNELS = [
  APPLE_WALLET_CHANNEL,
  GOOGLE_WALLET_CHANNEL,
  QR_CODE_CHANNEL,
  PRODUCT_QR_CODE_CHANNEL,
  PRODUCT_APPLE_WALLET_CHANNEL,
  PRODUCT_GOOGLE_WALLET_CHANNEL,
  PRODUCT_PURL_CHANNEL,
];
export const CHANNEL_TO_REDUCER_MAP: Record<string, string> = {
  [APPLE_WALLET_CHANNEL]: "appleWallet",
  [GOOGLE_WALLET_CHANNEL]: "googleWallet",
  [QR_CODE_CHANNEL]: "qr",
  [PRODUCT_QR_CODE_CHANNEL]: "qr",
  [PRODUCT_APPLE_WALLET_CHANNEL]: "appleWallet",
  [PRODUCT_GOOGLE_WALLET_CHANNEL]: "googleWallet",
  [PRODUCT_PURL_CHANNEL]: "referral",
};

export interface Referral {
  code: string;
  link: string;
  id: string;
  merchantId: string;
}
export interface StoreState {
  appleWallet: Partial<Referral>;
  error: error.StoreState;
  googleWallet: Partial<Referral>;
  isLoading: isLoading.StoreState;
  qr: Partial<Referral>;
  referral: Partial<Referral>;
}

export const initialState = {
  appleWallet: {},
  googleWallet: {},
  qr: {},
  referral: {},
};

// The channel is typically going to be purl,
// but due to the nature of v1 we can't guarantee that
// so we only carve out qr as a special case
export const reducer = combineReducers<StoreState>({
  appleWallet: appleWallet.reducer,
  error: error.reducer,
  googleWallet: googleWallet.reducer,
  isLoading: isLoading.reducer,
  qr: qr.reducer,
  referral: referral.reducer,
});
